// S vector.js
export interface ICoordinate {
    x: number;
    y: number;
}

export default class Vector {
    x = 0;
    y = 0;
    constructor(point: ICoordinate | undefined) {
        if (point === undefined) {
            this.x = 0;
            this.y = 0;
        } else {
            this.x = point.x;
            this.y = point.y;
        }
    }
    getMagnitude() {
        return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
    }

    add(vector: ICoordinate) {
        const v = new Vector(undefined);
        v.x = this.x + vector.x;
        v.y = this.y + vector.y;
        return v;
    }

    subtract(vector: ICoordinate) {
        const v = new Vector(undefined);
        v.x = this.x - vector.x;
        v.y = this.y - vector.y;
        return v;
    }

    dotProduct(vector: ICoordinate) {
        return this.x * vector.x + this.y * vector.y;
    }

    // 由两点生成边
    edge(vector: ICoordinate) {
        return this.subtract(vector);
    }

    // 垂直，即投影轴
    perpendicular() {
        const v = new Vector(undefined);
        v.x = this.y;
        v.y = 0 - this.x;
        return v;
    }

    normalize() {
        const v = new Vector(undefined),
            m = this.getMagnitude();

        if (m !== 0) {
            v.x = this.x / m;
            v.y = this.y / m;
        }
        return v;
    }

    // 投影轴的单位向量
    normal() {
        const p = this.perpendicular();
        return p.normalize();
    }
}
